import type * as api from '@gitbook/api-client';
import type { NavigationScreenState } from '@gitbook/app-navigation';
import { Icon } from '@gitbook/spine-icons';
import { Button, Description, Heading, Image } from '@gitbook/spine-react';

import { emptySpaceState } from '../../../assets';
import { ChangeRequestsButton } from '../ChangeRequest';
import { EditSpaceButton } from '../Header/EditSpaceButton';

export function PageEmptyState(props: { space: api.Space; screen: NavigationScreenState }) {
    const { space, screen } = props;

    const hasChangeRequests = space.changeRequestsOpen > 0 || space.changeRequestsDraft > 0;

    return (
        <div className="relative size-full">
            <Image
                src={emptySpaceState}
                className="pointer-events-none absolute inset-0 size-full rounded-none object-cover opacity-80"
            />
            <div className="relative z-10 flex size-full flex-col items-center gap-6 px-6 pt-20 md:justify-center md:pt-8 md:pb-44">
                <div className="flex size-14 items-center justify-center rounded-full border bg-base/60 p-3.5 shadow backdrop-blur">
                    {hasChangeRequests ? (
                        <Icon.ChangeRequest className="size-full" />
                    ) : (
                        <Icon.ChangeRequestNew className="size-full" />
                    )}
                </div>

                <div className="text-center">
                    <Heading
                        level={1}
                        className="text-content-heading-small md:text-content-heading-medium"
                    >
                        {hasChangeRequests
                            ? 'Make changes to your pages'
                            : 'Create your first change request'}
                    </Heading>
                    <Description className="text-content-paragraph">
                        {hasChangeRequests
                            ? 'Re-open a change request to make changes to your pages'
                            : 'Start making changes to your pages using our Git style workflow'}
                    </Description>
                </div>

                {!hasChangeRequests ? (
                    <EditSpaceButton space={space} />
                ) : screen.type === 'space' ? (
                    <ChangeRequestsButton
                        label="See all change requests"
                        space={space}
                        screen={screen}
                        kind="secondary"
                        leadingIcon={Icon.ChangeRequest}
                    />
                ) : (
                    <Button
                        label="See all change requests"
                        kind="primary"
                        href={{
                            screen: {
                                ...screen,
                                type: 'space',
                                space: space.id,
                                organization: space.organization,
                                sideSheet: { type: 'change-requests' },
                            },
                        }}
                    />
                )}
            </div>
        </div>
    );
}
